
<template>
    <div>
        <vs-dialog v-model="active" prevent-close width="800px" @close="borrarInfo">
            <template #header> 
                <h4 class="not-margin">
                    Editar información
                </h4>
            </template>

            <form autocomplete="off" @submit.prevent="postVincularHermano()">
                <div class="con-form">
                    <form autocomplete="off">
                        <vs-row>
                            <vs-col sm="12" lg="6">
                                <vs-input :loading="loadingSearch" v-model="findHermano" placeholder="Buscar"  @input="getBuscador(findHermano)"  class="px-0 pb-0">
                                </vs-input>
                                <div v-if="findHermano != ''" @click="findHermano = ''; hermano_id = ''" class="tache">
                                    <i class="far fa-times-circle"></i>
                                </div>
                                <div style="background: #F2F3F4; padding: 1%;" v-if="sinInfo == true && findHermano.length >= 4">
                                    No hay información
                                </div>
                                <div style="background: #F2F3F4; padding: 1%;"  v-if="showMinimo">
                                    Al menos 4 letras
                                </div>
                                <div v-if="data[0] && ocultarOpciones == true " class="list-group listAlumno">
                                    <div v-for="alumno in data" :key="alumno.id" @click="select(alumno)" class="list-group-item" style="cursor: pointer;">
                                        <div>
                                            <p v-text="alumno.full_name" class="m-0"></p>
                                        </div>
                                    </div>
                                </div>
                            </vs-col>
                            <vs-col sm="12" lg="6" class="mb-2 px-3">
                                <div class="p-2 divisionLineas" v-for="(hermanos, i) in hermanosVinculados" :key="i">
                                    <h6>{{hermanos.apellido_paterno}} {{hermanos.apellido_materno}} {{hermanos.nombres}}</h6>
                                    <div class="d-flex justify-content-between">
                                        <p class="mb-0"><small>MATRÍCULA: </small>{{hermanos.matricula}}</p>
                                    </div>
                                </div>
                            </vs-col>
                        </vs-row>
                        <vs-row class="mt-4">
                            <vs-col sm="12" lg="6" class="mb-2 p-2" v-for="(familiar, i) in hermanoSeleccionado" :key="i">
                                <vs-row style="border: 1px solid #EAECEE; border-radius: 7px;" >
                                    <vs-col class="py-1 px-2"  sm="10" lg="10">
                                        <h6>{{familiar.apellido_paterno}} {{familiar.apellido_materno}} {{familiar.nombres}}</h6>
                                        <div class="d-flex justify-content-between">
                                            <p class="mb-0"><small>MATRÍCULA</small>{{familiar.matricula}}</p>
                                        </div>
                                    </vs-col>
                                    <vs-col class="py-1 px-2 text-right"  sm="10" lg="2">
                                        <i class="fas fa-times" @click="removeHermano(i)"></i>
                                    </vs-col>
                                </vs-row>
                            </vs-col>
                        </vs-row>
                    </form>
                </div>
        
                <div class="d-flex mt-4">
                    <div @click="borrarInfo()">
                        <div class="botonCancelar">
                            Cancelar
                        </div>
                    </div>
                    <vs-button
                        success
                        type="submit"
                        class="ml-auto"
                    >
                        Guardar
                    </vs-button>
                </div>
            </form>
        </vs-dialog>
    </div>  
</template>
<script>
import hermanos from './hermanos.vue'
import alumnos from '../../../../../../api/requests/alumno'
import Axios from 'axios';
export default {
    props:[
      'value',
      'general'
    ],
    data(){
        return{
            active: false,
            // HERMANO 
            findHermano: '',
            hermanosVinculados: [],
            message: 'Al menos 4 letras...',
            messageShow: false,
            data: [],
            hidden: true,
            loadingSearch: false,
            sinInfo: false,
            showMinimo: false,
            hermanoSeleccionado: [],
            ocultarOpciones: false,
            hermano_id:'',
            mostrarOpciones: false,
            tiempo: ''
        }
    },
    components: {
        hermanos
    },
    methods:{
        async getHermanosVinculados(){
            if(this.general.datos.persona_id){
                try{
                    const { data: response } = await alumnos.getHermanosVinculados(this.general.datos.persona_id)
                    this.hermanosVinculados = Object.values(response)
                }catch{

                }
            }
        },
        getBuscador(info){
            const vm = this
            clearTimeout(vm.tiempo)
            if(info.length >= 4){
                vm.tiempo = setTimeout(() => {
                    this.loadingSearch = true
                    this.sinInfo = false
                    this.showMinimo = false
                    Axios.get('/panel/buscar/hermanos', {params: {text: info}}).then(res => {
                        this.ocultarOpciones = true
                        this.hidden = false
                        this.data = res.data;
                        if(this.data[0]){
                        }else{
                            this.sinInfo = true
                        }
                        this.loadingSearch = false
                    }).catch(e => {
                        this.ocultarOpciones = false
                        this.sinInfo = false
                        this.loadingSearch = false
                        if(this.$store.state.debug) {
                            toastr["error"](e, 'Error al buscar otros alumnos');
                        }
                    });
                }, 1000);
            }else{
                this.showMinimo = true
            }
        },
        select(info) {
            this.ocultarOpciones = false
            this.hermanoSeleccionado.push(info)
        },
        removeHermano(id){
            this.hermanoSeleccionado.splice(id, 1)
        },
        async postVincularHermano(){
            const loading = this.$vs.loading()
            try{
                const params = {ids : []}
                this.hermanoSeleccionado.forEach(element => {
                    params.ids.push(element.id)
                })
                const { data: response } = await alumnos.postVincularHermano(this.general.datos.persona_id, params)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        icon: '<i class="fas fa-check"></i>',
                        title: 'Operación éxitosa',
                        text: 'La vinculación entre hermanos ha sido correcta'
                    })
                    loading.close()
                    this.$emit('refreshComponent', this.general.datos.persona_id)
                    this.borrarInfo()
            }catch(error){
                console.log(error)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    duration: 5000,
                    position: null,
                    title: 'Algo salío mal',
                    text: 'Favor de comunicarse con el administrador'
                })
                loading.close()
                this.borrarInfo()
            }
        },
        borrarInfo(){
            this.hermanoSeleccionado = []
            this.findHermano = ''
            this.active = false
        }
    },
    watch:{
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        general(){
            this.getHermanosVinculados()
        }
    }
}
</script>

<style lang="scss" scoped>
    .tache{
        position: absolute;
        cursor: pointer;
        top: 25px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 2em);
        }

    }
    .divisionLineas:not(:last-child){
        border-bottom: 1px solid #E5E7E9; 
    }
    .divisionLineas{
        padding: 2% 0;
    }
</style>